import { Dialog, DialogContent, DialogTitle, List, ListItem } from "@mui/material";
import { useEffect, useMemo, useState } from 'react';
import { loadPrivateAutomationRules } from '../../actions';
import { RuleModel, RuleStatus, RuleType } from '../../models/auto-alert.model';
import { AutoAlertRulesService } from '../../services/AutoAlertRulesService';
import { ActionLabels, DialogHeaders, GridStatusLabelVariant, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles } from '../shared/constants';
import { Tooltip } from '@mui/material';
import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from '../../helpers/header.helper';
import setToast from '../../helpers/toaster.helper';
import { CancelIcon, EditIcon, StartIcon, StopIcon, TrashIcon } from '../../icon';
import * as selector from '../../selectors/selectors';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { CustomFilterCategory } from '../shared/filters/filter.model';
import GridComponent from '../shared/grid';
import { dateComparator, HeaderTemplate } from '../shared/grid/grid.services';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { ToasterType } from '../shared/toaster/toaster.model';
import AddRuleComponent from './add-rule.component';
import { useLocation } from "react-router-dom";

interface Props {
    SearchInput: string;
    AppliedFilters?: RuleModel[];
    editStartHandler: (value: any) => void;
    editStartOption: boolean
    editOptionHandler: (value: any) => void;
    editOption: boolean;
    refreshData?: () => void;
    onGridReady: (params: any) => void;
    runLoader: () => void;
    filterOptions: CustomFilterCategory[];
    selectedFilterTypes: string[];
    gridApi: any;
    resetFilters?: any;
    IsAutoReply: boolean;
}

const PrivateRuleComponent = (props: Props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PrivateRules: RuleModel[] = useSelector(selector.privateRules)

    const [editoption, setEditoption] = useState<boolean>(false);
    const [OperatingRowId, setOperatingRowId] = useState<string>("");
    const [OperatingRule, setOperatingRule] = useState<RuleModel>(null);
    const [Row, setRow] = useState<any>({});
    const [IsDeleteInProgress, setIsDeleteInProgress] = useState<boolean>(false);
    const [ShowRowMenu, setShowRowMenu] = useState<boolean>(false);
    const [ShowDeleleConfirmation, setShowDeleleConfirmation] = useState<boolean>(false);
    const [ShowPauseResumeConfirmation, setShowPauseResumeConfirmation] = useState<boolean>(false);
    const [IsPauseResumeInProgress, setIsPauseResumeInProgress] = useState<boolean>(false);
    const [Text, setText] = useState<string>("");
    const [ButtonName, setButtonName] = useState<string>("");
    const [privateRules, SetPrivateRules] = useState<RuleModel[]>()


    const filteredRules = useMemo(() => {
        return PrivateRules.filter(
            x => x.Type === (props.IsAutoReply ? RuleType.AUTO_REPLY : RuleType.KEYWORD)
        );
    }, [PrivateRules, props.IsAutoReply]);

    useEffect(() => {
        if (location.pathname === AppRoutes.AUTOMATION_KEYWORD) {
            setHeaderTitle(pageTitles.AUTOMATION_RULES_KEYWORDS);
        } else {
            setHeaderTitle(pageTitles.AUTOMATION_RULES);
        }
        setHeaderCount(filteredRules.length || 0);
        setRefreshHandler(refreshData);
        SetPrivateRules(filteredRules);
    }, [filteredRules, location.pathname]);


    const refreshData = (successCallBack?: () => void, hideLoader?: boolean) => {
        props.resetFilters()
        loadPrivateAutomationRules(dispatch).then(() => {
        }).then(successCallBack);
    }

    const handleStart = (e: any) => {
        e.preventDefault();
        startOrstopRule(true);
    }

    const openAddRule = (rowId: string, obj?: RuleModel) => {
        setEditoption(true);
        setOperatingRule(obj);
        setOperatingRowId(rowId);
        props.editOptionHandler(true);
    }

    const closeAddRule = (isConfim: boolean) => {
        setEditoption(false);
        setOperatingRule(undefined);
        setOperatingRowId('');
        props.editOptionHandler(false);
        refreshData()
    };

    const openStartRule = (rowId: string, obj?: RuleModel) => {
        setOperatingRule(obj);
        setOperatingRowId(rowId);
        props.editStartHandler(true)
    }

    const closeStartRule = (isConfim: boolean) => {
        setOperatingRule(undefined);
        setOperatingRowId('');
        props.editStartHandler(false)
        refreshData()
    };

    const openDeleteConfirmDialog = (rule: RuleModel) => {
        setShowDeleleConfirmation(true);
        setOperatingRowId(rule.ID);
        setOperatingRule(rule);
        setText(appNote.AUTO_ALERT_RULE_DELETE);
        setButtonName(buttonLabels.DELETE);
    };

    const openPauseResumeConfirmDialog = (rule: RuleModel) => {
        setShowPauseResumeConfirmation(true);
        setOperatingRowId(rule.ID);
        setOperatingRule(rule);
        setText(appNote.AUTO_ALERT_RULE_STOP);
        setButtonName(buttonLabels.STOP);
    };

    const closePauseResumeDialog = (isConfirm: boolean, e?: any) => {
        if (!!isConfirm) {
            startOrstopRule(false);
        }
        else {
            setIsPauseResumeInProgress(false);
            setOperatingRowId("");
            setOperatingRule(undefined);
            setShowPauseResumeConfirmation(false);
        }
    }

    const startOrstopRule = (isStart: boolean) => {
        setIsPauseResumeInProgress(true);
        var RuleObj = privateRules.find((x: RuleModel) => x.ID === OperatingRowId);
        AutoAlertRulesService.updateRuleStatus(OperatingRowId)
            .then(res => {
                if (!props.editStartOption && !isStart) {
                    setToast(ToasterTexts.AUTO_ALERT_RULE_STOP_SUCCESS.replace('<Name>', RuleObj?.Name || ""), ToasterType.SUCCESS);
                }
                setShowPauseResumeConfirmation(false);
                setOperatingRowId("");
                setOperatingRule(undefined);
                setIsPauseResumeInProgress(false);
                props.editStartHandler(false);
                if (!isStart) {
                    refreshData()
                }
            })
            .catch(err => {
                if (props.editStartOption) {
                    setToast(ToasterTexts.AUTO_ALERT_RULE_STOP_FAILED.replace('<Name>', RuleObj?.Name || ""), ToasterType.DANGER);
                }
                setShowPauseResumeConfirmation(false);
                setOperatingRowId("");
                setOperatingRule(undefined);
                setIsPauseResumeInProgress(false);
            })
    }

    const closeDeleteDialog = (isConfirm: boolean) => {
        if (isConfirm) {
            setIsDeleteInProgress(true);
            var RuleObj = privateRules.find((x: RuleModel) => x.ID === OperatingRowId);
            AutoAlertRulesService.deleteAutoAlertRule(OperatingRowId)
                .then(res => {
                    if (isConfirm) {
                        setToast(ToasterTexts.AUTO_ALERT_RULE_DELETE_SUCCESS.replace('<Name>', RuleObj?.Name || ""), ToasterType.SUCCESS)
                    }
                    refreshData()
                    setShowDeleleConfirmation(false);
                    setOperatingRowId("");
                    setOperatingRule(undefined);
                    setIsDeleteInProgress(false);
                })
                .catch(err => {
                    if (!isConfirm) {
                        setToast(ToasterTexts.AUTO_ALERT_RULE_DELETE_FAILED.replace('<Name>', RuleObj?.Name || ""), ToasterType.DANGER);
                    }
                    setShowDeleleConfirmation(false);
                    setOperatingRowId("");
                    setOperatingRule(undefined);
                    setIsDeleteInProgress(false);
                })
        }
        else {
            setShowDeleleConfirmation(false);
            setOperatingRowId("");
            setOperatingRule(undefined);
            setIsDeleteInProgress(false);
        }
    }

    const handleRowClick = (row: any) => {
        if (IsMobileDevice) {
            setShowRowMenu(true);
            setRow(row);
        }
    };

    const closeMenu = () => {
        setShowRowMenu(false);
    }

    const ColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Rule Name",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.replaceSpacesWithNBSP(params?.data?.Name);
            },
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "15px" } : null,
        },
        {
            field: "Keyword",
            headerName: "Keyword",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Keyword;
            },
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            hide: props.IsAutoReply,
            resizable: true,
        },
        {
            field: "Status",
            headerName: "Status",
            resizable: true,
            valueGetter: (params: ValueGetterParams) => {
                return (params.data as RuleModel).Status === RuleStatus.ACTIVE ? "Active" : (params.data as RuleModel).Status === RuleStatus.INACTIVE ? "Inactive" : "Completed"
            },
            headerComponentParams: {
                template: props.selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            cellRendererSelector: params => {
                if (params.data) {
                    const label = (params.data as RuleModel).Status === RuleStatus.ACTIVE ? "Active" : (params.data as RuleModel).Status === RuleStatus.INACTIVE ? "Inactive" : "Completed";
                    const variant = params.data.Status === RuleStatus.ACTIVE || params.data.Status === RuleStatus.COMPLETED ? GridStatusLabelVariant.Active : GridStatusLabelVariant.Danger;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID,
                        }
                    }
                    return Status;
                }
            },
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.CreatedDateTime).toString(),
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            resizable: true,
        },
        {
            field: "Action",
            maxWidth: 130,
            headerName: "Action",
            cellRenderer: params => <div className="d-flex">
                {getMenuActions(params)?.filter(x => !x.Hide)?.map(x => <div>
                    <Tooltip title={x.Name} placement='top'>
                        <x.Icon className="ml-2 c-pointer" onClick={() => x.OnClick()} />
                    </Tooltip>
                </div>)}
            </div>,
        },
    ]

    const getMenuActions = (params) => {
        return [{
            Name: ActionLabels.EDIT,
            Icon: EditIcon,
            OnClick: () => openAddRule((params.data as RuleModel)?.ID, params.data),
        },
        {
            Name: (params.data as RuleModel).Status === RuleStatus.ACTIVE ? ActionLabels.STOP : (params.data as RuleModel).Status === RuleStatus.INACTIVE ? ActionLabels.START : ActionLabels.START,
            Icon: (params.data as RuleModel).Status === RuleStatus.ACTIVE ? StopIcon : StartIcon,
            Hide: (params.data as RuleModel)?.Status === RuleStatus.COMPLETED,
            OnClick: () => (params.data as RuleModel).Status === RuleStatus.INACTIVE ? openStartRule((params.data as RuleModel)?.ID, params.data) : openPauseResumeConfirmDialog((params.data as RuleModel)),
        },
        {
            Name: ActionLabels.DELETE,
            Icon: TrashIcon,
            OnClick: () => openDeleteConfirmDialog((params.data as RuleModel)),
        },
        ]
    }


    const handleCellRowClick = (e: any, row: RuleModel) => {
        if (!IsMobileDevice && e.colDef.field !== "Action") {
            openAddRule(row?.ID, row)
        }
    }

    return (
        <>
            <GridComponent
                ColumnDefs={ColoumnDefs}
                RowData={privateRules}
                OnGridReady={props.onGridReady}
                OnGridRowClick={handleRowClick}
                IsPaginationEnabled={false}
                EmptyLabel={emptyLabels.RULES}
                LockVisible={IsMobileDevice}
                filterOptions={props.filterOptions}
                IsFilterPresent={true}
                gridApi={props.gridApi}
                OnGridCellRowClick={handleCellRowClick}
                ShowRowPointer={true}
            />
            {
                props.editOption && (
                    <AddRuleComponent OnClose={closeAddRule} Show={editoption} Rule={OperatingRule} PageTitle={OperatingRule?.ID ? DialogHeaders.EDIT_RULE : DialogHeaders.ADD_RULE} ButtonLabel={buttonLabels.SAVE} HandleSubmitSuccess={() => refreshData()} IsAutoReply={OperatingRule.Type === RuleType.AUTO_REPLY} />
                )
            }
            {
                props.editStartOption && (
                    <AddRuleComponent OnClose={closeStartRule} Show={props.editStartOption} Rule={OperatingRule} PageTitle={"Start Rule"} ButtonLabel={buttonLabels.START} HandleSubmitSuccess={handleStart} ShowLoader={IsPauseResumeInProgress} />
                )
            }
            {
                ShowDeleleConfirmation && (
                    <ConfirmDialog
                        onClose={closeDeleteDialog}
                        Show={ShowDeleleConfirmation}
                        Text={Text}
                        ButtonName={ButtonName}
                        IsMobileDevice={IsMobileDevice}
                        Loading={IsDeleteInProgress}
                    />
                )
            }
            {
                ShowPauseResumeConfirmation && (
                    <ConfirmDialog
                        onClose={closePauseResumeDialog}
                        Show={ShowPauseResumeConfirmation}
                        Text={Text}
                        ButtonName={ButtonName}
                        IsMobileDevice={IsMobileDevice}
                        Loading={IsPauseResumeInProgress}
                    />
                )
            }
            {
                IsMobileDevice && ShowRowMenu && (
                    <Dialog
                        fullWidth
                        maxWidth="sm"
                        onClose={closeMenu}
                        aria-labelledby="responsive-dialog-title"
                        open={true}
                        classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
                    >
                        <DialogTitle className="pb-1">
                            <div
                                className="h1 color-display-title d-flex"
                                id="customized-dialog-title"
                            >
                                {!!Row?.Name && UtilityService.containsWhitespace(Row?.Name) ? Row?.Name : UtilityService.trimMessage(Row?.Name, 18)}
                                <span className="ml-auto">
                                    <Tooltip title="Close" placement="bottom">
                                        <CancelIcon
                                            className={"c-pointer"}
                                            onClick={closeMenu}
                                        />
                                    </Tooltip>
                                </span>
                            </div>
                        </DialogTitle>
                        <DialogContent className={"mln-1 o-hidden"}>
                            <List className={"pt-0"}>
                                <ListItem
                                    className={"px-1 py-1 h2 color-menu-list-font-color"}
                                    button
                                    onClick={() => {
                                        openAddRule(Row.ID, Row)
                                        closeMenu();
                                    }}
                                >
                                    <EditIcon className={"mr-1"} />
                                    <span className={"h4-regular color-menu-list-font-color"}>{ActionLabels.EDIT}</span>
                                </ListItem>
                                {
                                    Row.Status === 0 ?
                                        <ListItem
                                            className={"px-1 py-1 h2 color-menu-list-font-color"}
                                            button
                                            onClick={() => {
                                                openPauseResumeConfirmDialog(Row)
                                                closeMenu();
                                            }}
                                        >
                                            <StopIcon className={"mr-1"} />
                                            <span className={"h4-regular color-menu-list-font-color"}>{ActionLabels.STOP}</span>
                                        </ListItem> : Row.Status === 1 ? <ListItem
                                            className={"px-1 py-1 h2 color-menu-list-font-color"}
                                            button
                                            onClick={() => {
                                                openStartRule(Row.ID, Row)
                                                closeMenu();
                                            }}
                                        >
                                            <StartIcon className={"mr-1"} />
                                            <span className={"h4-regular color-menu-list-font-color"}>{ActionLabels.START}</span>
                                        </ListItem> : ""
                                }

                                <ListItem
                                    className={"px-1 py-1 h2 color-menu-list-font-color"}
                                    button
                                    onClick={() => {
                                        openDeleteConfirmDialog(Row)
                                        closeMenu();
                                    }}
                                >
                                    <TrashIcon className={"mr-1"} />
                                    <span className={"h4-regular color-menu-list-font-color"}>{ActionLabels.DELETE}</span>
                                </ListItem>
                            </List>
                        </DialogContent>
                    </Dialog>
                )
            }
        </>
    )

}
export default PrivateRuleComponent;